export default "__VITE_ASSET__ByjuJ2gK__"